import React from 'react';
import InfoTip from '../../components/InfoTip';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
} from 'recharts';

// Piezas de gráficas compartidas por los indicadores de Recepción y Alistamientos,
// con la misma paleta del Reporte 360 v2.
export const COLORS = {
  navy: '#0F3460',
  green: '#0E9F6E',
  coral: '#FC536D',
  lightBlue: '#7BA7D4',
  amber: '#E9A13B',
};

export const fmtNum = (n, d = 0) => Number(n || 0).toLocaleString('es-CO', { maximumFractionDigits: d });

const truncate = (s, max = 22) => (s && s.length > max ? `${s.slice(0, max)}…` : s);

export const ChartBox = ({ title, hint, info, children, height = 280 }) => (
  <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200/80 dark:border-gray-700/80 shadow-sm p-5">
    <h3 className="text-sm font-bold text-[#001F41] dark:text-white tracking-tight flex items-center gap-1.5">
      {title}
      {info && <InfoTip>{info}</InfoTip>}
    </h3>
    {hint && <p className="text-[11.5px] text-[#43474F] dark:text-gray-400 mt-0.5">{hint}</p>}
    <div className="mt-3" style={{ height }}>
      {children}
    </div>
  </div>
);

export const EmptyChart = ({ text = 'Sin datos en el periodo.' }) => (
  <div className="h-full flex items-center justify-center text-sm text-gray-500 dark:text-gray-400">{text}</div>
);

export const dayAxisProps = (count) => {
  const many = count > 14;
  return {
    dataKey: 'fecha',
    tick: { fontSize: 11 },
    interval: many ? 'preserveStartEnd' : 0,
    angle: many ? -45 : 0,
    textAnchor: many ? 'end' : 'middle',
    height: many ? 45 : 25,
  };
};

// Barras horizontales para rankings (top clientes, prendas, etc.)
export const HorizontalBars = ({ data, dataKey, name, color = COLORS.navy, unit = '', decimals = 0 }) => {
  if (!data || data.length === 0) return <EmptyChart />;
  return (
    <ResponsiveContainer>
      <BarChart data={data} layout="vertical" margin={{ top: 0, right: 20, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" horizontal={false} />
        <XAxis type="number" tick={{ fontSize: 11 }} />
        <YAxis
          type="category"
          dataKey="nombre"
          width={150}
          tick={{ fontSize: 11 }}
          tickFormatter={(v) => truncate(v)}
          interval={0}
        />
        <Tooltip formatter={(v) => `${fmtNum(v, decimals)}${unit}`} />
        <Bar dataKey={dataKey} name={name} fill={color} radius={[0, 3, 3, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};
